export const CREATE_CREDIT_NOTE  = 'CREATE_CREDIT_NOTE';
export const GET_CREDIT_NOTES  = 'GET_CREDIT_NOTES';
export const GET_CREDIT_NOTES_PAGE  = 'GET_CREDIT_NOTES_PAGE';
export const CREDIT_NOTE_REQUEST  = 'CREDIT_NOTE_REQUEST';
export const DELETE_CREDIT_NOTE  = 'DELETE_CREDIT_NOTE';
export const UPDATE_CREDIT_NOTE  = 'UPDATE_CREDIT_NOTE';
export const CREDIT_NOTE_REQUEST_SUCCESS  = 'CREDIT_NOTE_REQUEST_SUCCESS';
export const CREDIT_NOTE_REQUEST_FAILURE  = 'CREDIT_NOTE_REQUEST_FAILURE';